export default {
  user: undefined,
  activeInvite: null,
}
